<template>
  <div>
    <div class="v-input mt-1 v-input--selection-controls v-input--hide-details">
      <div class="v-input__control">
        <div class="v-input__slot">
          <div class="v-input--selection-controls__input" @click="selectAll">
            <div class="v-input--selection-controls__ripple primary--text"></div>
            <i class="v-icon mdi mdi-add theme--light" :class="allCheckedClass"></i>
          </div>

          <div class="v-label theme--light hvh-strong d-inline-block">
            <label class="d-inline" style="left: 0; right: auto; position: relative" @click="selectAll" ref="label">{{ category.label }}</label>
          </div>
          <a class="pl-2 v-label theme--light mdi" :class="expandClass" @click.prevent="expanded = !expanded"></a>
        </div>
      </div>
    </div>

    <div v-if="expanded">
      <InputCheckbox
        v-for="(child, ind) in category.children"
        class="mt-1 hvh-analysis-segments__checkbox--lvl2 hvh-soft"
        v-model="child.checked"
        :color="child.color"
        :key="child.label + ind"
        :text="child.label"
        @change="emitChange(category.children)"
      />
    </div>
  </div>
</template>

<script>
import InputCheckbox from '../common/form/inputCheckbox/HvhInputCheckbox';

export default {
  components: { InputCheckbox },
  props: ['category'],
  data() {
    return {
      expanded: true,
    };
  },
  methods: {
    emitChange() {
      this.$emit('change', this.category.children.filter(f => f.checked));
    },
    selectAll() {
      var shouldSelect = this.category.children.find(f => !f.checked) != null;
      this.category.children.forEach(f => f.checked = shouldSelect);
      this.emitChange();
    }
  },
  computed: {
    allCheckedClass() {
      return (this.allSelected ? ('mdi-checkbox-marked ' + this.color + '--text') : 'mdi-checkbox-blank-outline theme-light');
    },
    allSelected() {
      return this.category.children.find(f => f.checked) != null;
    },
    color() {
      return this.category.children.find(f => !f.checked) == null ? 'primary' : 'grey';
    },
    expandClass() {
      return this.expanded ? 'mdi-minus-box-outline' : 'mdi-plus-box-outline';
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.label.parentNode.style['width'] = (this.$refs.label.offsetWidth + 1) + 'px';
    });
  }
};
</script>

<style lang="scss">
.hvh-strong {
  font-weight: bolder;
}

.hvh-soft {
  font-style: italic;
}
</style>
